module.exports = __webpack_public_path__ + "media/images/loader-eacf4775c73ecc123114f0d437dc4ed9.gif";